var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-overlay-wrapper"},[_c('div',{staticClass:"c-content-wrapper"},[_c('div',{staticClass:"c-splash-loader-lines"}),_vm._v(" "),_c('div',{staticClass:"c-loading-txt"},[_vm._v("Učitavanje podataka..  ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-199d7f9e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/OverlayLoader.vue
// module id = null
// module chunks = 